import {
  NetworkEventData,
  RCEvent,
  EventName,
  EventType,
} from "../../core/eventhub/eventmodels.js";
import { EventController } from "../../core/eventhub/eventcontroller.js";
import { RidecellCallback } from "../../core/models/ridecellcallback.js";
import { CarsharingNetworkRequests } from "../networkrequestsbuilder.js";

export class RentalController {
  getRental(overrideQueryParams) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        role: "CUSTOMER",
        ...overrideQueryParams,
      };

      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.rental,
        queryParams //queryData
      );

      const getRentalCallback = new RidecellCallback();
      getRentalCallback.onSuccess = (response) => {
        const result = response.results[0];
        resolve(result);
      };

      getRentalCallback.onFailure = (error) => {
        reject(error);
      };
      this.sendEvent(
        new RCEvent(EventName.NETWORK, requestData, getRentalCallback)
      );
    });
  }

  sendEvent(event) {
    EventController.addEvent(event);
  }
}
